import { render, staticRenderFns } from "./NpaReport.vue?vue&type=template&id=bd4bb5f4"
import script from "./NpaReport.vue?vue&type=script&lang=js"
export * from "./NpaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports